import { compose, path } from "ramda";

export const scopeSelector = state => state.modules.referral;

export const sendInvitationApi = compose(
  path(["api", "sendInvitation"]),
  scopeSelector
);

export const sendInsiderInvitationApi = compose(
  path(["api", "sendInsiderInvitation"]),
  scopeSelector
);

export const acceptInvitation = compose(
  path(["api", "acceptInvitation"]),
  scopeSelector
);

export const validateInsiderInvitationApi = compose(
  path(["api", "validateInsiderInvitation"]),
  scopeSelector
);



// WEBPACK FOOTER //
// ./src/modules/referral/selectors.js